import Footer from "../../commons/footer";
import Header from "../../commons/header";
import EducationsMain from "./main";

const Educations = () => {
    return (
        <div className="educations-page">
            <Header />
            <EducationsMain />
            <Footer />
        </div>
    )
};

export default Educations;